import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function ChatTestimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonials = [{
    userMsg: 'Me trabé con farmacocinética. Abrí el Tomo 4 y encontré el esquema exacto que necesitaba con ejemplos clínicos. Lo entendí en 20 minutos y lo expliqué en el oral sin problemas. Me pusieron un 9.',
    brandMsg: 'Qué bueno 🥹 El Tomo 4 está pensado para que farmaco deje de ser un monstruo. Seguí así.',
    name: 'Martina P.',
    info: '3er año UNR · Rosario',
    initials: 'MP',
    color: 'bg-pink-500'
  }, {
    userMsg: 'Aprobé Anatomía! El Tomo 2 me salvó la vida. Las mnemotecnias son clave, nunca pensé que me iba a acordar de todos los pares craneales.',
    brandMsg: '¡Felicitaciones! 🎉 Anatomía es un filtro enorme, qué orgullo que el material te haya servido.',
    name: 'Tomás R.',
    info: '1er año UBA · CABA',
    initials: 'TR',
    color: 'bg-blue-500'
  }, {
    userMsg: 'Estoy usando el planificador del Nivel 3 y por primera vez siento que tengo el control de la cursada. Ya no estudio a las apuradas el día antes.',
    brandMsg: 'Esa es la actitud 💪 La organización es el 50% de la carrera. A seguir rompiéndola.',
    name: 'Lucía M.',
    info: '4to año UNC · Córdoba',
    initials: 'LM',
    color: 'bg-emerald-500'
  }];
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section className="w-full bg-slate-100 py-12 md:py-20 px-4" data-id="element-40">
      <div className="max-w-3xl mx-auto" data-id="element-41">
        <div className="text-center mb-10" data-id="element-42">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2" data-id="element-43">
            Lo que dicen los estudiantes que ya lo usan:
          </h2>
          <p className="text-slate-600" data-id="element-44">
            +1.800 estudiantes de todo el país ya tienen la carrera de Medicina
            organizada.
          </p>
        </div>

        <div className="relative bg-white rounded-2xl shadow-sm border border-slate-200 p-4 md:p-8 mb-6 min-h-[300px] flex flex-col justify-center" data-id="element-45">
          <AnimatePresence mode="wait" data-id="element-46">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.3
          }} className="w-full" data-id="element-47">
              <div className="flex flex-col gap-4" data-id="element-48">
                {/* User Bubble */}
                <div className="flex justify-end w-full" data-id="element-49">
                  <div className="bg-slate-100 text-slate-800 p-4 rounded-2xl rounded-tr-sm max-w-[85%] shadow-sm relative" data-id="element-50">
                    {testimonials[currentIndex].userMsg}
                  </div>
                </div>

                {/* Brand Bubble */}
                <div className="flex justify-start w-full" data-id="element-51">
                  <div className="bg-brand-blue text-white p-4 rounded-2xl rounded-tl-sm max-w-[85%] shadow-sm relative" data-id="element-52">
                    {testimonials[currentIndex].brandMsg}
                  </div>
                </div>
              </div>

              <div className="mt-8 flex items-center gap-3 justify-center border-t border-slate-100 pt-6" data-id="element-53">
                <div className={`w-10 h-10 rounded-full ${testimonials[currentIndex].color} text-white flex items-center justify-center font-bold text-sm`} data-id="element-54">
                  {testimonials[currentIndex].initials}
                </div>
                <div className="text-left" data-id="element-55">
                  <div className="font-bold text-slate-900 text-sm" data-id="element-56">
                    {testimonials[currentIndex].name}
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-57">
                    {testimonials[currentIndex].info}
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex items-center justify-center gap-6" data-id="element-58">
          <button onClick={prev} className="p-2 rounded-full bg-white shadow hover:bg-slate-50 text-slate-600 transition-colors" data-id="element-59">
            <ChevronLeft size={24} data-id="element-60" />
          </button>
          <div className="text-sm font-bold text-slate-500" data-id="element-61">
            {currentIndex + 1} / {testimonials.length}
          </div>
          <button onClick={next} className="p-2 rounded-full bg-white shadow hover:bg-slate-50 text-slate-600 transition-colors" data-id="element-62">
            <ChevronRight size={24} data-id="element-63" />
          </button>
        </div>
      </div>
    </section>;
}